import React, {Component} from 'react';
import Banner from './Banner';
import MobileMegaNav from './MobileMegaNav';
import CurrentConditions from './CurrentConditions';
import Cannonicalize from '../Cannonicalize'
import OutsideScriptManager from '../OutsideScriptManager'
import Analytics from '../Analytics'
import Url from '../Url'
import Bot from '../Bot'

class Header extends Component {
  constructor(props) {
    super(props)
    this.state = {
      mobileMegaNavOpen: false,
      banners: Cannonicalize.banner(),
      hideHeader: false
    }
  }

  componentWillMount() {
    try {
      this.setState({
        banners: Cannonicalize.banner(this.props.FRN_rawResponses[0].data),
        hideHeader: Url.params(this.props.FRN_page).hideHeader === "true"
      })
    } catch (e) {
      e.message+= 'in Header'
      Analytics.reportError(e)
    }

  }

  componentDidMount() {
    if (typeof window == 'object' && this.state.hideHeader !== true) {
      try{  this.createHeaderAd()}
      catch(e){
        e.message += 'in Header Advert'
        Analytics.reportError(e)
      }

    }

  }

  createHeaderAd() {
      window.gptadslots = window.gptadslots || [];
      window.googletag = window.googletag || {
        cmd: []
      };

      if(window.innerWidth <= 991)
        this.createSmallAd()
      if(window.innerWidth >= 1200)
        this.createLargeAd()

  }


  createLargeAd =()=> {

    googletag.cmd.push(()=> {
      let contentClassification = window.franklyDataLayer[0].content_classification.replace(/[ ?/]/gi, '').toLowerCase();
      gptadslots.push(googletag.defineSlot('/43459271/loc-desktop/'+this.props.affiliate+ '/web/' + contentClassification, [
        [728, 90]
      ], 'header-ad-container-lg').addService(googletag.pubads()));
      console.log('Header updated createLargeAd used %s','/43459271/loc-desktop/'+this.props.affiliate+ '/web/' + contentClassification)
      googletag.pubads().setTargeting('wnsz',['41']).enableSingleRequest();
      googletag.enableServices();
    });

    window.googletag.cmd.push(function() {
      googletag.display('header-ad-container-lg')
    }); //large header ad

  }

  createSmallAd = () => {

    googletag.cmd.push(()=> {
      let contentClassification =window.franklyDataLayer[0].content_classification.replace(/[ ?/]/gi, '').toLowerCase();
      gptadslots.push(googletag.defineSlot('/43459271/loc-desktop/'+this.props.affiliate+ '/web/' + contentClassification, [
        [320, 50]
      ], 'header-ad-container-sm').addService(googletag.pubads()));
      console.log('Header createSmallAd used %s','/43459271/loc-desktop/'+this.props.affiliate+ '/web/' + contentClassification)
      googletag.pubads().setTargeting('wnsz',['41']).enableSingleRequest();
      googletag.enableServices();
    });
    googletag.cmd.push(function() {
      googletag.display('header-ad-container-sm');
    });
  }

  toggleMobileMegaNav = () => {
    this.setState({
      mobileMegaNavOpen: !this.state.mobileMegaNavOpen
    })
  }

  render() {
    if(this.state.hideHeader === true) //This removes the header padding, that is normally set in 'Banner'
      return <div dangerouslySetInnerHTML={{__html: `
                <style>
                  #gnm-main-body, .PageGrid.PageBody.container{
                    padding-top: 0px;
                  }
                </style>
              `}}></div>


    return (<div className='gnm-header'>
      <Banner affiliate={this.props.affiliate} bannersFeed={this.state.banners} watchLiveSponsorship={this.props.watchLiveSponsorship}/>
      <div id='gnm-header-without-banner'>
        <div className='container'>
          <div className='pull-left'>
            <button onClick={this.toggleMobileMegaNav.bind(this)} className={'dark-icon-bar-container ' + (
                this.state.mobileMegaNavOpen
                ? 'active'
                : '')}>
              <div className='dark-icon-bar'/>
              <div className='dark-icon-bar'/>
              <div className='dark-icon-bar'/>
              <span>MENU</span>
            </button>
          </div>
          <div className='pull-left '>
            <a href='/'>
              <img width="auto" height="auto" src={this.props.otsLogoUrl} className='big-ots img-responsive'/>
            </a>
          </div>
          <div className='pull-left visible-lg-block visible-md-block ' style={{
              width: '80px'
            }}>
            <a href='/'>
              <img  width="auto" height="auto" src={this.props.stackedLogoUrl} className='logo-stacked '/>
            </a>
          </div>
          <div className='pull-left visible-xs-block visible-sm-block'>
            <a href='/'>
              <img  width="auto" height="auto" src={this.props.otsLogoUrl} className='logo-ots img-responsive'/>
            </a>
          </div>
          <div className='pull-left visible-lg-block'>
            <div className="ad728" id='header-ad-container-lg'/>
          </div>
          <div className='pull-left visible-md-block'>
            <a href={this.props.advertiseUrl}>
              <img  width="auto" height="auto" className='ad640' src='https://ftpcontent.worldnow.com/kotv/test/don/build/img/ad-md-640x100.jpg'/>
            </a>

          </div>
          <div className='pull-left visible-sm-block'>
            <div className='ad320' id='header-ad-container-sm'/>
          </div>
          <div className='pull-right'>
            <CurrentConditions affiliate={this.props.affiliate}/>
          </div>
        </div>
      </div>
      <MobileMegaNav affiliate={this.props.affiliate} nav={this.props.nav} open={this.state.mobileMegaNavOpen} toggle={this.toggleMobileMegaNav}/>
    </div>);
  }
}

export default Header;



// WEBPACK FOOTER //
// ./app/components/custom/ssr/Header/index.js